import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "claEmptyDash",
  standalone: false,
})
export class EmptyDashPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    if (!value) {
      return "—";
    }
    return value;
  }
}
